import Repository from './Repository'
const URL_GET_DOCTOR_INFO = '/auth/doctor-info'
const URL_FIRST_RESET_PASSWORD = 'auth/first-reset-password'
const URL_SEND_RESET_LINK = 'auth/send-reset-link'
const URL_RESET_PASSWORD = 'auth/reset-password'
const URL_REFRESH_TOKEN = '/auth/refresh-token'
const URL_REFRESH_TOKEN_FOR_PHARMACY = '/pharmacy/auth/refresh-token'
const URL_UPDATE_DOCTOR = '/doctors'
const URL_LOGIN = '/auth/login'
const URL_LOGIN_FROM_DR_NANAMEDI = 'nanamedi-dr/auth/login'
const URL_LOGIN_FOR_PHARMACY = 'pharmacy/auth/login'
const URL_ACCESS_CHECK = '/access_check'
const URL_CHANGE_EMAIL = 'auth/change-email'
const URL_CONFIRM_CHANGE_EMAIL = 'auth/confirm-change-email'
const URL_RESEND_CONFIRMATION_CODE = 'auth/resend-confirmation-code'
const URL_VERIFY_MFA = "/auth/verify-mfa"
const URL_CHECK_LOGIN_DEVICE = "/auth/device"
const URL_GET_ATTRIBUTE_USER = "/auth/get-attributes"
const URL_ADD_PHONE_NUMBER = "/auth/add-phone-number"
const URL_CONFIRM_PHONE_NUMBER = "/auth/confirm-phone-number"
const URL_SET_MFA = "/auth/set-mfa"

export default {
  loginWithPharmacy (payload) {
    return Repository.post(URL_LOGIN_FOR_PHARMACY, payload)
  },
  login (payload) {
    return Repository.post(URL_LOGIN, payload)
  },
  loginFromDrNanamedi (payload) {
    return Repository.post(URL_LOGIN_FROM_DR_NANAMEDI, payload)
  },
  getDoctorInfo () {
    return Repository.get(URL_GET_DOCTOR_INFO)
  },
  firstResetPassword (payload) {
    return Repository.post(URL_FIRST_RESET_PASSWORD, payload)
  },
  sendResetLink (payload) {
    return Repository.post(URL_SEND_RESET_LINK, payload)
  },
  resetPassword (payload) {
    return Repository.post(URL_RESET_PASSWORD, payload)
  },
  refreshToken (payload) {
    if (JSON.parse(localStorage.getItem('vuex')).auth.typeOfUser === 'pharmacy') {
      return Repository.get(URL_REFRESH_TOKEN_FOR_PHARMACY, payload)
    }
    else {
      return Repository.get(URL_REFRESH_TOKEN, payload)
    }
  },
  updateDoctor (payload) {
    return Repository.put(URL_UPDATE_DOCTOR, payload)
  },
  checkAccess() {
    return Repository.get(URL_ACCESS_CHECK)
  },
  changeEmail(payload) {
    return Repository.post(URL_CHANGE_EMAIL, payload)
  },
  confirmChangeEmail(payload) {
    return Repository.post(URL_CONFIRM_CHANGE_EMAIL, payload)
  },
  resendConfirmationCode(payload) {
    return Repository.post(URL_RESEND_CONFIRMATION_CODE, payload)
  },
  verifyMfa(payload) {
    return Repository.post(URL_VERIFY_MFA, payload)
  },
  checkLoginDevice(payload) {
    return Repository.post(URL_CHECK_LOGIN_DEVICE, payload)
  },
  getAttributeUser(payload) {
    return Repository.post(URL_GET_ATTRIBUTE_USER, payload)
  },
  addPhoneNumber(payload) {
    return Repository.post(URL_ADD_PHONE_NUMBER, payload)
  },
  confirmPhoneNumber(payload) {
    return Repository.post(URL_CONFIRM_PHONE_NUMBER, payload)
  },
  setMFA(payload) {
    return Repository.post(URL_SET_MFA, payload)
  }
}
